module.exports = __webpack_public_path__ + "static/media/orange_animal_reptiles.0b65e941.png";